import { Link, useSearchParams } from "react-router";
import introVideo from "/intro.webm";
import Button from "../layouts/Button";
import { useRef, useState } from "react";
import playButton from "/play-button.svg";

export default function Intro() {
	// Get redirect url
	const [searchParams, _setSearchParams] = useSearchParams();

	const redirect = searchParams.get("redirect");

	// Handle video pause/play
	const [isVideoEnded, setIsVideoEnded] = useState(false);
	const videoRef = useRef<HTMLVideoElement>(null);
	const overlayRef = useRef<HTMLDivElement>(null);

	const triggerPausePlay = () => {
		const video = videoRef.current;
		const overlay = overlayRef.current;
		if (!video || !overlay) return;

		if (video.paused) {
			video.play();
			overlay.style.display = "none";
		} else {
			video.pause();
			overlay.style.display = "";
		}
	};

	return (
		<>
			<div
				className="min-h-screen flex flex-col justify-center items-center bg-black"
				onClick={() => triggerPausePlay()}
			>
				<video
					className="w-full max-h-screen"
					onEnded={() => {
						setIsVideoEnded(true);
					}}
					ref={videoRef}
					playsInline
				>
					<source src={introVideo} type="video/webm" />
				</video>
				<div
					className="absolute text-white text-4xl font-bold select-none"
					ref={overlayRef}
				>
					<img src={playButton} alt="Play" className="w-24 h-24" />
				</div>
			</div>
			{isVideoEnded && (
				<div className="absolute bottom-4 right-4">
					<Link
						to={
							"/experience" +
							(redirect ? `?redirect=${encodeURIComponent(redirect)}` : "")
						}
					>
						<Button>Go to Experience</Button>
					</Link>
				</div>
			)}
		</>
	);
}
